module.exports = __webpack_public_path__ + "static/img/cocina_12.4d0a2cec.png";